import React, { useState, useEffect } from 'react'
import { Calendar, momentLocalizer, Views } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import '../App.css';
import axios from 'axios';
import AddExclusionTimePopup from './AddExclusionTimePopUp';
import CopyExclusionTimePopUp from './CopyExclusionTimePopUp';
import moment from 'moment'
import {
    SERVER_URI
} from "../utility/config";
require("moment/locale/fi")


function ExclusionCalendar(props) {
    props.stopListRefresh()
    const [exclusions, setExclusions] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenCopy, setIsOpenCopy] = useState(false);
    const localizer = momentLocalizer(moment)

    useEffect(() => {
        const fetchData = async () => {
            let exclusionsList = props.exclusionTimes
            for (let t = 0; t < exclusionsList.length; t++) {
                exclusionsList[t].startTime = moment(exclusionsList[t].startTime).toDate();
                exclusionsList[t].endTime = moment(exclusionsList[t].endTime).toDate();
            }
            setExclusions(exclusionsList)
        }
        fetchData();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const eventStyleGetter = (event) => {
        var style = {
            backgroundColor: '#ff9999',
            color: 'black',
            border: '0px',
            display: 'block',
            padding: '7px 6px 0px 6px'
        };
        return {
            style: style
        };
    }

    const TitleComponent = (event) => {
        return (
            <span>  Kuvaus:<br /> {event.event.description} </span>
        )
    }
    const togglePopUpAddExclusion = () => {
        setIsOpen(!isOpen);
    }

    const togglePopUpCopyExclusion = async () => {
        setIsOpenCopy(!isOpenCopy)
    }

    const onSelectEvent = (pEvent) => {
        const confirmDelete = window.confirm("Poistetaanko valittu poikkeusaika?")
        const exclusionTimeId = pEvent.exclusionTimeId
        let storage = window.localStorage;
        let userToken = storage.getItem("admin_token")

        if (confirmDelete === true) {
            axios.delete(`${SERVER_URI}/remove_order_exclusion_time/${exclusionTimeId}`, { headers: { "Authorization": `Token ${userToken}` } })
                .catch(function (error) {
                    console.log(error);
                });
            const events = [...exclusions]
            const exclusionIndex = events.indexOf(pEvent)
            events.splice(exclusionIndex, 1);
            setExclusions(events)
            props.dispatch({ type: "DELETE_EXCLUSION", data: { exclusion: exclusionIndex } })
        }
    }
    return (<div className="calendar-container">
        <>
            <h4>Poikkeusajat</h4>
            <button id="CalendarButton" onClick={togglePopUpAddExclusion} >Lisää poikkeusaika</button>
            <button id="CalendarButton" onClick={togglePopUpCopyExclusion} >Kopioi poikkeusaikoja</button>
            <Calendar
                popup
                localizer={localizer}
                events={exclusions}
                components={{
                    event: TitleComponent
                }}
                defaultView={Views.MONTH}
                views={['month', 'day', 'week']}
                step={60}
                timeslots={1}
                messages={{
                    month: "Kuukausi",
                    day: "Päivä",
                    next: "Seuraava",
                    previous: "Edellinen",
                    today: "Tänään",
                    week: "Viikko",
                    title: "Kuvaus:"
                }}
                min={new Date(0, 0, 0, 0, 0, 0)}
                max={new Date(0, 0, 0, 23, 59, 0)}
                scrollToTime={new Date(1970, 1, 1, 6)}
                defaultDate={new Date()}
                onSelectEvent={event => onSelectEvent(event)} //Fires selecting existing event
                titleAccessor='description'
                startAccessor='startTime'
                endAccessor='endTime'
                eventPropGetter={(eventStyleGetter)}
            />
            {isOpen && (
                <AddExclusionTimePopup dispatch={props.dispatch} handleClose={togglePopUpAddExclusion} />
            )}
            {isOpenCopy && (
                <CopyExclusionTimePopUp dispatch={props.dispatch} handleClose={togglePopUpCopyExclusion} exclusions={props.exclusionTimes} />
            )}
        </>
    </div>
    );
}

export default ExclusionCalendar